/* @flow */

import {trigger as edapTrigger} from './edapWrapper';
import {PP_ACCEPTED} from '../constants/badges';
import type {Shape as MapHitShape} from '../components/MapHit/MapHit';
import type {Shape as HitShape} from '../components/Hit/Hit';
import type {HitBadge, PartnerBadge} from '../components/HitInfo/HitInfo';

export const LIST_HIT_CLICK = 'search.hit.click';
export const MAP_HIT_CLICK = 'search.map.hit.click';
export const MAP_MARKER_CLICK = 'search.map.property.click';

type HitEdapEventAction =
    | typeof LIST_HIT_CLICK
    | typeof MAP_HIT_CLICK
    | typeof MAP_MARKER_CLICK;

type Hit = MapHitShape | HitShape;

type Badges = {
    partnerBadges: ?Array<PartnerBadge>
};

/* This filters out badges we get from SRS that are currently using the
graphql-traveler-badges service.
TODO: remove this after we have migrated all badges to graphql-traveler-badges */
export function filterBadges(
    badges: ?(HitBadge[]),
    {partnerBadges}: Badges = {}
) {
    let badgesConcat = badges || [];

    const indexOfPremierPartner = badgesConcat.indexOf(PP_ACCEPTED);

    if (indexOfPremierPartner !== -1) {
        badgesConcat.splice(indexOfPremierPartner, 1);
    }

    if (partnerBadges) {
        badgesConcat.push('PP_ACCEPTED');
    }

    return badgesConcat.join(',');
}

const triggerHitEdapEvent = (
    hit: Hit,
    eventCategory: HitEdapEventAction,
    delayProcessing?: boolean
) => {
    const options = {delayProcessing};
    const {badges, partnerBadges} = hit;

    const filteredBadges = filterBadges(badges, {partnerBadges});
    edapTrigger(
        eventCategory,
        {
            eventlistingids: hit.listingId,
            absoluteposition: hit.absolutePosition.toString(),
            relativeposition: hit.relativePosition.toString(),
            badges: filteredBadges
        },
        options
    );
};

export const triggerListHitClickEDAPEvent = (hit: Hit) => {
    triggerHitEdapEvent(hit, LIST_HIT_CLICK, true);
};

export const triggerMapHitClickEDAPEvent = (hit: Hit) => {
    triggerHitEdapEvent(hit, MAP_HIT_CLICK, true);
};

export const triggerMarkerClickEDAPEvent = (hit: Hit) => {
    triggerHitEdapEvent(hit, MAP_MARKER_CLICK);
};
